import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { TrimCreatorForm } from "./TrimCreatorForm";
import type {
  LocaleYearMakeData,
  SearchResponse,
  TrimCreateRequest,
  TrimMap
} from "@dealer-center/inventory-pages-gvm-interface";
import {
  useGetModelBodyStyle,
  useGetTrimToCloneList,
  useGetTrimWithDetails,
  useTrimCreate
} from "@dealer-center/inventory-pages-gvm-fetch";

const StyledTrimCreatorPage = styled.div`
  padding-left: 10px;
  padding-top: 10px;
  width: 100%;
  z-index: 999;
`;

function newTrimMap(
  thirdPartyId: string,
  thirdPartyVehicleTrimId: string
): TrimMap {
  return {
    recordId: "",
    thirdPartyId,
    globalVehicleTrimId: "",
    thirdPartyVehicleTrimId,
    manuallyCreated: true,
    active: true
  };
}

type TrimCreatorPageProps = SearchResponse<LocaleYearMakeData>;

export const TrimCreatorPage = (props: TrimCreatorPageProps) => {
  const [trimCreateRequest, setTrimCreateRequest] = useState<TrimCreateRequest>(
    {
      stage: "LIVE",
      locale: "US_EN"
    }
  );
  const modelSearchResponse = useGetModelBodyStyle(trimCreateRequest);
  const trimToCloneSearchResponse = useGetTrimToCloneList(trimCreateRequest);
  const trimSearchResponse = useGetTrimWithDetails(trimCreateRequest);
  const createTrimMutation = useTrimCreate();

  useEffect(() => {
    const newMappings = trimSearchResponse.data?.trimMapList
      ?.filter(
        trim =>
          trim.thirdPartyId !== "AUTODATA" &&
          trim.thirdPartyId !== "IDT_SHOWROOM"
      )
      .map(trim => newTrimMap(trim.thirdPartyId, trim.thirdPartyVehicleTrimId));

    setTrimCreateRequest({
      ...trimCreateRequest,
      mappings: newMappings || []
    });
  }, [trimSearchResponse.data]);

  const render = () => {
    return (
      <StyledTrimCreatorPage>
        <TrimCreatorForm
          createTrimMutation={createTrimMutation}
          localeYearMakeSearchResponse={props}
          modelSearchResponse={modelSearchResponse}
          setTrimCreateRequest={setTrimCreateRequest}
          trimCreateRequest={trimCreateRequest}
          trimSearchResponse={trimSearchResponse}
          trimToCloneSearchResponse={trimToCloneSearchResponse}
        />
      </StyledTrimCreatorPage>
    );
  };

  return render();
};
